import { t } from '@lingui/core/macro';
import { createFileRoute } from '@tanstack/react-router';

import { ParticipantTagsManager } from '../-components/participant-tags-manager';
import { SettingsSection } from '../../settings/-components/settings-section';
import { SETTINGS_HELP } from '../../settings/-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/organization-settings/team/tags',
)({
  component: ParticipantTagsPage,
  head: () => ({ meta: [{ title: t`Participant tags` }] }),
});

function ParticipantTagsPage() {
  const { activeDashboard } = Route.useRouteContext();
  return (
    <SettingsSection
      title={t`Participant tags`}
      description={t`Labels your team can add to participants in the participant database.`}
      helpUrl={SETTINGS_HELP.general}
    >
      <ParticipantTagsManager teamId={activeDashboard.team ?? ''} />
    </SettingsSection>
  );
}
